export default "__VITE_ASSET__Bi7K1ZWn__"